import Header from '../components/Header';
import About from '../components/About';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const AboutPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <About />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default AboutPage;
